import React from "react";
import { useAuth } from "providers/Auth";
import { DEFAULT_SIGIL_LINKS } from "types/configs";

function AuthorizedComponent({
  minMembership,
  minRole,
  minMembershipMessage,
  minRoleMessage,
  children,
}) {
  const { hasValidMembership, hasValidRole } = useAuth();

  if (!hasValidMembership(minMembership)) {
    return (
      <div>
        {minMembershipMessage} Please contact your customer representative or
        email{" "}
        <a href={`mailto:${DEFAULT_SIGIL_LINKS.supportEmail}`}>
          {DEFAULT_SIGIL_LINKS.supportEmail}
        </a>{" "}
        for assistance.
      </div>
    );
  }

  if (!hasValidRole(minRole)) {
    return (
      <div>
        {minRoleMessage} Please contact your customer representative or email{" "}
        <a href={`mailto:${DEFAULT_SIGIL_LINKS.supportEmail}`}>
          {DEFAULT_SIGIL_LINKS.supportEmail}
        </a>{" "}
        for assistance.
      </div>
    );
  }

  return <>{children}</>;
}

export default AuthorizedComponent;
